import * as React from 'react';
import { cn } from '@/lib/utils';
import DefaultBanner from '@/assets/images/canaleducacao/Boas_vindas_CanalEducacao.png';
import EgepiBanner from '@/assets/images/egepi/EgepiBanner.png';
import { Button } from '@/components/ui/button';

const WarningWallImg = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn('c-warning-wall-img', 'h-[260px] w-full shrink-0 grow object-cover xl:w-[280px]', className)}
    {...props}
  />
));
WarningWallImg.displayName = 'WarningWallImg';

const WarningWallContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-warning-wall-content', 'flex grow flex-col gap-2 bg-white p-6', className)}
    {...props}
  />
));
WarningWallContent.displayName = 'WarningWallContent';

const WarningWallHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-warning-wall-header', '', className)}
    {...props}
  />
));
WarningWallHeader.displayName = 'WarningWallHeader';

const WarningWallBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-warning-wall-body', 'grow', className)}
    {...props}
  />
));
WarningWallBody.displayName = 'WarningWallBody';

const WarningWallFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-warning-wall-footer', '', className)}
    {...props}
  />
));
WarningWallFooter.displayName = 'WarningWallFooter';

const WarningWallTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('c-warning-wall-title', 'mb-0 line-clamp-2 max-h-[76px] text-3xl font-bold text-primary', className)}
    {...props}
  />
));
WarningWallTitle.displayName = 'WarningWallTitle';

const WarningWallDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-warning-wall-description', 'mb-0 line-clamp-3 text-[1.125rem] font-light text-neutral-dark', className)}
    {...props}
  />
));
WarningWallDescription.displayName = 'WarningWallDescription';

const WarningWall = React.forwardRef(({ className, warning, ...props }, ref) => {
  const appName = process.env.REACT_APP_NAME;

  const imageSource = React.useMemo(() => {
    if (warning) {
      if (warning?.image) {
        return warning?.image.url || DefaultBanner;
      }
      return DefaultBanner;
    } else {
      if (appName === 'egepi') {
        return EgepiBanner;
      } else {
        return DefaultBanner;
      }
    }
  }, [warning]);

  return (
    <div
      ref={ref}
      className={cn('c-warning-wall', 'relative mb-10 flex min-h-[260px] flex-col overflow-hidden rounded-xl border border-solid border-neutral-lightest bg-[#FAFAFA] shadow-dropshadow-lg xl:flex-row', className)}
      {...props}
    >
      <WarningWallImg
        src={imageSource}
        alt="imagem do aviso"
      />

      {warning?.link && warning?.image && (
        <Button
          variant="outline"
          wide
          className="absolute bottom-3 right-6"
          asChild
        >
          <a
            href={warning?.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {warning.label || 'Acessar'}
          </a>
        </Button>
      )}

      {!warning?.image && warning?.title && warning?.description && (
        <WarningWallContent>
          <WarningWallHeader>
            <WarningWallTitle title={warning?.title}>{warning?.title}</WarningWallTitle>
          </WarningWallHeader>

          <WarningWallBody>
            <WarningWallDescription title={warning?.description}>{warning?.description}</WarningWallDescription>
          </WarningWallBody>

          {warning?.link && (
            <WarningWallFooter>
              <Button
                variant="outline"
                wide
                asChild
              >
                <a
                  href={warning?.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {warning.label || 'Acessar'}
                </a>
              </Button>
            </WarningWallFooter>
          )}
        </WarningWallContent>
      )}
    </div>
  );
});
WarningWall.displayName = 'WarningWall';

export { WarningWall };
